export default "__VITE_ASSET__BJe6BGTU__"